// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalEligibilityResultSearchResponse } from './medicalEligibilityResultSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalV1MedicalV1MedicalEligibilityResultSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': MedicalEligibilityResultSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalV1MedicalV1MedicalEligibilityResultSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "MedicalEligibilityResultSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalV1MedicalV1MedicalEligibilityResultSearchDefaultResponse.attributeTypeMap;
    }
}
